import SessionStore from "../../session/SessionStore";
import {observable} from 'mobx'
import * as mobx from 'mobx'
import * as addressApi from './addressApi'
import {countryMatches} from "./util";

export class CountryStore {

  @observable countries = []
  @observable loaded = false

  constructor() {
    SessionStore.onceLoaded()
      .then(() => addressApi.listCountries())
      .then(mobx.action('setInitialized', countries => {
        this.countries = countries
        this.loaded = true
      }))
  }

  onceLoaded() {
    return mobx.when(() => this.loaded)
  }

  resolve(countryId) {
    const lower = countryId.toLowerCase()
    return mobx.when(() => this.loaded)
      .then(() => this.countries.find(x => countryMatches(lower, x)))
  }

  adhoc(countryId) {
    return {
      id: countryId,
      name: countryId,
      alternateNames: [],
      settings: {}
    }
  }


  validate(postalAddress) {
    const get = (field) => (postalAddress[field] && postalAddress[field].trim()) || ''
    const countryName = get('addressCountry');
    if (!countryName) {
      return Promise.resolve(['addressCountry'])
    } else {
      return this.resolve(countryName)
        .then(maybe => {
          const country = maybe || this.adhoc(countryName)
          const requirements =
            []
              .concat(country.settings.includeCity ? ['addressLocality'] : [])
              .concat(country.settings.includeState ? ['addressRegion'] : [])
              .concat(country.settings.includePostalCode ? ['postalCode'] : [])

          return requirements.filter(rq => !get(rq))
        })
    }
  }


}

export default new CountryStore()